import { getPlayerName } from '../../utils/misc';
import type { HistoricalData } from '../../utils/types';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const MultiplePlayerCarouselCard = ({
  data: { cardType, cardImg, season, goalScored, topScorers },
  language,
}: {
  data: HistoricalData;
  language: string;
}) => {
  const t = useTranslateFn();
  return (
    <div className={`${styles['ts-historical-carousel__card']} ${styles[cardType]}`}>
      <img src={cardImg} alt='players' />
      <div className={`ts-historical-carousel__card--competition-logo season-${season}`} />
      <div className={styles['ts-historical-carousel__card--season-year']}>{season}</div>
      <div className={styles['ts-historical-carousel__card--player-info']}>
        <div className={styles['ts-historical-carousel__card--player-list']}>
          <div className={styles['ts-historical-carousel__card--player-name']}>
            <ul>
              {topScorers.map((player, i) => (
                <li key={`item-${i}`}>{getPlayerName(player, language)}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className={styles['ts-historical-carousel__card--goals']}>
          {goalScored} {t('stats_goals')}
        </div>
      </div>
    </div>
  );
};

export default MultiplePlayerCarouselCard;
